import React, { useEffect, useState, useCallback, useRef }from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from "react-router-dom";

import T, { Translate } from '../../i18n/i18n';
import { Row, TableList, FindTables, HubStatus, TableItemCell, NoTable, TableItemNewTitle, TableItemNewData, TableItemNewOK, TableItemNewCancel, TableItemNewLabel, TableItemNewInput, Title, TableItemNew, TableItemSideAdd, TableItemSideJoin, ButtonIcon, HeaderRow, NotificationError, Link, Action, TableItemSideTemplates, TableItemTemplates, StatusRow, StatusLink, StatusLabel, StatusIcon, TablesCounter, Button} from './TablesList.styles';
import { listTables, createTable, joinTable, denyJoinTable, confirmJoinTable } from '../../../services/tables';
import { getHome } from '../../../services/user';
import TableItem from '../TableItem/TableItem';
import TableItemFull from '../TableItem/TableItemFull';
import { loadingActions, profilesActions } from '../../../redux/actions';

const emptyTable = {
    name: "",
};

export default () => {
    const [joining, setJoining] = useState(false);
    const [tables, setTables] = useState([]);
    const [hightlight, setHightlight] = useState(null);
    const [updateStatus, setUpdateStatus] = useState({});
    const [twitchStatus, setTwitchStatus] = useState({});
    const [premiumStatus, setPremiumStatus] = useState(false);
    const [error, setError] = useState(null);
    const [maxTables, setMaxTables] = useState(null);
    const [currentTables, setCurrentTables] = useState(null);
    const [code, setCode] = useState('');

    const dispatch = useDispatch();
    const history = useHistory();
    const updateListingInterval = useRef(null);

    const updateTables = useCallback(async ()=> {
        let tables = await listTables();
        let max = tables.payload.max ?? '3';
        let current = tables.payload.current ?? '0';
        setMaxTables(parseInt(max));
        setCurrentTables(parseInt(current));
        setTables(tables.payload.tables);
    }, []);

    useEffect(()=> {
        (async () => {
            let home = await getHome();
            setHightlight(home.hightlight);
            setUpdateStatus(home.update ?? {});
            setTwitchStatus(home.twitch ?? {});
            setPremiumStatus(home.isPremium ?? false);
            dispatch(profilesActions.setDonate(home.apoiaseTarget, home.apoiaseCurrent, home.isPremium))
        })();
    }, []);

    useEffect(() => {
        if (typeof updateTables === 'function') {
            updateTables();
            updateListingInterval.current = setInterval(() => {
                updateTables();
            }, 60000);
        }

        return () => {
            clearInterval(updateListingInterval.current);
        }
    }, [updateTables]);

    const openTable = (item) => {
        if (item.joined === 0) {
            history.push(`/table/${item._id}`);
        }
    }

    const openTableView = ({id}) => {
        history.push(`/home/table/${id}`);
    }

    const handleAddNew = () => {
        history.push(`/home/table/new`);
    }

    const handleJoin = () => {
        setCode('');
        setJoining(true);
    }

    const handleCancel = () => {
        setJoining(false);
    }

    const handleConfirmCode = async () => {
        setJoining(false);
        let tables = await joinTable({code});
        if (tables.payload.tables) {
            setTables(tables.payload.tables);
        }
    }

    const handleConfirmJoin = async (table) => {
        let tables = await confirmJoinTable(table._id);
        setTables(tables.payload.tables || []);
    }

    const handleDenyJoin = async (table) => {
        let tables = await denyJoinTable(table._id);
        setTables(tables.payload.tables || []);
    }

    const handleRefresh = () => {
        setTables([]);
        dispatch(loadingActions.loadingStart('tablesList.handleRefresh'));
        setTimeout(() => {
            updateTables();
            clearInterval(updateListingInterval.current);
            updateListingInterval.current = setInterval(() => {
                updateTables();
            }, 60000);
            dispatch(loadingActions.loadingEnd('tablesList.handleRefresh'));
        }, 200);
    }

    const handleGoToTemplates = () => {
        history.push(`/home/templates`);
    }

    const handleGoToFindTable = () => {
        history.push(`/home/tables`);
    }

    return <>
        <Row>
            <FindTables>
                <Title><T value="tables.findtables" /></Title>
                <TableItemFull onOpen={hightlight ? openTableView : null} table={hightlight ?? emptyTable}  />
                <Button color="#fc0" className='full' onClick={handleGoToFindTable}><T value="tables.gototables" /></Button>
            </FindTables>
            <HubStatus>
                <Title><T value="tables.hubstatus" /></Title>
                <div>
                    <StatusRow color="#FFF238">
                        { updateStatus.status === 'maintenance' ? <>
                            <StatusIcon icon={"\\F05B7"} color="#FFF238" className="pulse" />
                            <StatusLabel color="#FFF238" ><T value='tables.underMaintenance1' /><br /><T value='tables.underMaintenance2' /></StatusLabel>
                            <StatusLink color="#FFF238" href="/app/releases.html" ><T value="tables.viewRelease" /></StatusLink>
                        </> : <>
                            <StatusIcon icon={"\\F06B0"} color="#28BB2F" />
                            <StatusLabel color="#28BB2F" ><T value={'tables.updateStatus'} /><br />{updateStatus.date}</StatusLabel>
                            <StatusLink color="#28BB2F" href="/app/releases.html" ><T value="tables.viewRelease" /></StatusLink>
                        </>}
                    </StatusRow>

                    <StatusRow color="#E52">
                        {twitchStatus.online ? <>
                            <StatusIcon icon={"\\F1720"} color="#E52" className="pulse" />
                            <StatusLabel color="#E52" ><T value="tables.twitchOnline" /></StatusLabel>
                        </> : <>
                            <StatusIcon icon={"\\F1721"} color="#E52" />
                            <StatusLabel color="#E52"><T value="tables.nextLive" /><br />{twitchStatus.next}</StatusLabel>
                        </>}
                        <StatusLink color="#E52" href="https://twitch.tv/hubrpg"><T value="tables.goToTwitch" /></StatusLink>
                    </StatusRow> 

                    <StatusRow color="#79f">
                        <StatusIcon icon={"\\F04CE"} color="#79f" />
                        { !premiumStatus ? <>
                            <StatusLabel color="#79f" ><T value="tables.notpremium1" /><br /><T value="tables.notpremium2" /></StatusLabel>
                            <StatusLink color="#79f" href="https://apoia.se/hubrpg"><T value="tables.goToApoiase" /></StatusLink>
                        </> :
                            <StatusLabel color="#79f" ><T value="tables.thankyoupremium1" /><br /><T value="tables.thankyoupremium2" /></StatusLabel>
                        }
                    </StatusRow>
                </div>
            </HubStatus>
        </Row>
        <HeaderRow>
            <Title><T value="tables.title" /></Title>
            <ButtonIcon color="#f92" onClick={handleRefresh} icon="\F0450" title={Translate("tables.refresh")} />
            <TablesCounter>{Translate('tables.tablesCounter').replace('$1', currentTables).replace('$2', maxTables)}</TablesCounter>
        </HeaderRow>
        {error ? 
            <NotificationError>
                <div>
                    {error.message}
                </div>
                {error.type === 'limit' ? <Link href="https://apoia.se/hubrpg">
                    <T value="tables.gotoapoiase" />
                </Link> : null}
                <Action onClick={()=>{setError(null)}}><T value="tables.dismiss" /></Action>
            </NotificationError>
        : null }
        <TableList>
            {tables && tables.length ? tables.map((item, index) => <TableItem 
                key={index} 
                onOpen={openTable} 
                onAccept={handleConfirmJoin} 
                onDeny={handleDenyJoin} 
                table={item} 
            />) : <NoTable><T value="tables.noTable" /></NoTable>}
            {!joining && <TableItemCell className={'noBorder'}>
                <TableItemSideAdd onClick={()=>{handleAddNew()}}>
                    <TableItemNew><span className="mdi mdi-plus mdi-36px"></span><T value="tables.create" /></TableItemNew>
                </TableItemSideAdd>
                <TableItemSideJoin onClick={()=>{handleJoin()}}>
                    <TableItemNew><span className="mdi mdi-location-enter mdi-36px"></span><T value="tables.join" /></TableItemNew>
                </TableItemSideJoin>
            </TableItemCell>}
            {joining && <TableItemCell>
                <TableItemNewTitle><T value="tables.join" /></TableItemNewTitle>
                <TableItemNewLabel><T value="tables.code" /></TableItemNewLabel>
                <TableItemNewInput>
                    <TableItemNewData type="text" value={code} onChange={(e)=>{setCode(e.target.value)}}/>
                    <TableItemNewOK onClick={()=>{handleConfirmCode()}}><span className="mdi mdi-check mdi-18px"></span></TableItemNewOK>
                    <TableItemNewCancel onClick={()=>{handleCancel()}}><span className="mdi mdi-close mdi-18px"></span></TableItemNewCancel>
                </TableItemNewInput>
            </TableItemCell>}
            <TableItemCell className={'noBorder'}>
                <TableItemSideTemplates onClick={()=>{handleGoToTemplates()}}>
                    <TableItemTemplates><span className="mdi mdi-note-text-outline mdi-36px"></span><T value="tables.templates" /></TableItemTemplates>
                </TableItemSideTemplates>
            </TableItemCell>
        </TableList>
    </>
};